module.exports = __webpack_public_path__ + "static/img/tiggy_pictgrid23_1080x845.53aa00a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/tiggy_pictgrid23_1080x845.jpg
// module id = y07X
// module chunks = 0